import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "trigger"]
  static values = { id: String, hiddenClass: { type: String, default: "hidden" } }

  show() {
    this.contentTargets.forEach(element => element.classList.remove(this.hiddenClassValue))
    this.triggerTargets.forEach(element => element.classList.add("hidden"))
  }

  hide() {
    this.contentTargets.forEach(element => element.classList.add(this.hiddenClassValue))
    this.triggerTargets.forEach(element => element.classList.remove("hidden"))
  }

  toggle() {
    document.getElementById(this.idValue).classList.toggle("hidden")
    this.element.classList.toggle("toggle-label-active")
  }
}
